import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

class About extends React.Component {
  componentDidMount() {
    setPageMeta({
      title: "About",
      description:
        "Chisp Technologies runs two branches: a data consulting practice and an IoT monitoring division, staffed by the same engineering team.",
      path: "/about",
    });
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-chisp-navy">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8" className="mx-auto text-center">
                      <h1 className="display-3 text-white">
                        About{" "}
                        <span>Chisp Technologies</span>
                      </h1>
                      <p className="lead text-white">
                        An engineering team working across two branches: a data consulting
                        practice that builds and modernizes cloud data platforms, and an IoT
                        division that builds the connected devices feeding them.
                      </p>
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="shadow border-0" style={{ background: 'linear-gradient(135deg, #232b4d 0%, #2d365f 100%)' }}>
                    <CardBody className="p-lg-5">
                      <Row className="align-items-center">
                        <Col lg="6">
                          <h3 className="text-white mb-2">Our Mission</h3>
                          <p className="text-white">
                            To make serious data infrastructure reachable for organizations that
                            do not have a platform team of their own. Whether that means a
                            warehouse and the dashboards on top of it, or sensors on a job site
                            feeding a live alerting system, the work is the same: get reliable
                            data in front of the people who need to act on it.
                          </p>
                          <h3 className="text-white mb-2 mt-4">Our Vision</h3>
                          <p className="text-white">
                            A world where an operation of any size can see what is actually
                            happening across it &mdash; in the warehouse, on the factory floor, or
                            in the field &mdash; without needing deep technical expertise or
                            giving up control of its data.
                          </p>
                        </Col>
                        <Col lg="6">
                          <div className="text-center">
                            <img
                              alt="Chisp logo"
                              className="img-fluid"
                              src={require("assets/img/brand/chisp.png")}
                              style={{ width: "200px" }}
                            />
                            <h4 className="text-white mt-3">One Platform. Infinite Insight.</h4>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">What we do</h2>
                  <p className="lead text-muted">
                    One team, two branches. They share the same engineers, and often the
                    same project.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="6">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-database" />
                      </div>
                      <h5 className="text-primary">Data Consulting</h5>
                      <p className="description mt-3">
                        We design, build, and modernize the data platforms organizations run
                        on: cloud data architecture on AWS, warehousing with Snowflake and
                        Databricks, Power BI and Streamlit analytics, machine learning and
                        image analysis, and the custom applications that sit on top. We also
                        train client teams so they can extend the platform themselves.
                      </p>
                      <Button
                        className="btn-round mt-3"
                        color="primary"
                        to="/consulting"
                        tag={Link}
                      >
                        See our capabilities
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-sitemap" />
                      </div>
                      <h5 className="text-success">IoT Platform &amp; Devices</h5>
                      <p className="description mt-3">
                        The Chisp Hub and dashboard bring connected sensors, cameras, and
                        devices together under AI-powered monitoring with real-time alerting
                        and unified device management, deployed across industrial sites,
                        commercial spaces, and homes. It is our own product, and the proving
                        ground for much of what our consulting team builds.
                      </p>
                      <Button
                        className="btn-round mt-3"
                        color="success"
                        to="/platform"
                        tag={Link}
                      >
                        See the platform
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-team section-lg bg-gradient-default">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3 text-white">Meet our team</h2>
                  <p className="lead text-white">
                    Three founders covering client delivery, cloud architecture, and
                    hardware prototyping.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Jarret Ealy"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/jarret.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Jarret Ealy</span>
                        <small className="h6 text-muted">Co-Founder & CEO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-0">
                          Jarret spent over a decade in engineering sales and project management before
                          co-founding Chisp. He runs client engagements and keeps the technical work anchored to
                          what the business actually needs.
                        </p>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/jarretealy/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Adam Heimowitz"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/adam.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Adam Heimowitz</span>
                        <small className="h6 text-muted">Co-Founder & CTO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-0">
                          Adam is a cloud architect who has built and operated distributed systems across
                          multiple cloud platforms. He leads engineering and owns the architecture behind both
                          the consulting work and the IoT platform.
                        </p>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/adamheimowitz/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="Craig Wilkinson"
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("assets/img/theme/craig.jpeg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title text-white">
                        <span className="d-block mb-1">Craig Wilkinson</span>
                        <small className="h6 text-muted">Co-Founder & COO</small>
                      </h5>
                      <div className="text-white">
                        <p className="mb-0">
                          Craig turns rough ideas into working prototypes and establishes what is feasible
                          before anyone commits to it. He translates customer requirements into engineering
                          plans.
                        </p>
                      </div>
                      <div className="mt-3">
                        <Button
                          className="about-social-icon btn-icon-only btn-round"
                          href="https://www.linkedin.com/in/craig-wilkinson-b3429078/"
                          target="_blank"
                          rel="noopener noreferrer"
                          size="lg"
                        >
                          <i className="fa fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Our Values</h2>
                  <p className="lead text-muted">
                    The principles that guide everything we do at Chisp Technologies.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-lock" />
                      </div>
                      <h6 className="text-primary text-uppercase">
                        Privacy First
                      </h6>
                      <p className="description mt-3">
                        We believe your data belongs to you. Our systems are designed 
                        with privacy at their core, ensuring your information stays secure and private.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-lightbulb-o" />
                      </div>
                      <h6 className="text-success text-uppercase">
                        Innovation
                      </h6>
                      <p className="description mt-3">
                        We're constantly pushing the boundaries of what's possible with AI 
                        monitoring, creating solutions that are both cutting-edge and practical.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                        <i className="fa fa-heart" />
                      </div>
                      <h6 className="text-warning text-uppercase">
                        Simplicity
                      </h6>
                      <p className="description mt-3">
                        Complex technology should be simple to use. We focus on creating 
                        intuitive experiences that anyone can master.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Join Our Journey</h2>
                  <p className="lead text-white">
                    We're always looking for talented individuals who share our passion 
                    for intelligent monitoring and making technology more accessible.
                  </p>
                  <div className="btn-wrapper mt-4">
                    <Button
                      className="btn-neutral btn-icon mb-3 mb-sm-0"
                      color="default"
                      tag={Link}
                      to="/contact"
                    >
                      <span className="btn-inner--icon">
                        <i className="fa fa-envelope" />
                      </span>
                      <span className="btn-inner--text">Contact Us</span>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default About;
